module.exports = __webpack_public_path__ + "static/media/slackEmoji3.e104fb74.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/slackEmoji3.gif
// module id = 37
// module chunks = 0